import { Stack, Typography } from '@mui/material'
import { AddConfigButton } from '../common/AddConfigButton'
import { CONTENT } from '../../constants/constants'


/**
 * A functional component that renders the footer for the Global Config Table.
 * It includes an "Add Config" button and a note displayed as a caption.
 *
 * @component
 * @prop {Function} onAdd - Callback function to handle the "Add Config" button click event.
 * @returns {JSX.Element} The rendered footer component.
 */

export default function GlobalConfigTableFooter({ onAdd }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      paddingX={2}
      paddingY={1}
      sx={{ borderTop: (theme) => `1px solid ${theme.palette.divider}` }}
    >
      <AddConfigButton onClick={onAdd} sx={{ mt: 1 }} />
      <Typography
        variant="caption"
        textAlign="right"
        width="100%"
        display="block"
      >
        {CONTENT.general.encrypted_note}
      </Typography>
    </Stack>
  )
}
